import { jsxs as g, jsx as p } from "react/jsx-runtime";
import { FormikContext as L } from "formik";
import { useContext as O, useState as n, useCallback as S, useMemo as E, useEffect as q } from "react";
import { dateFromString as m, formatDate as b } from "../../utils/date.es.js";
import { useMultiStyleConfig as w, chakra as z } from "@chakra-ui/react";
import { INPUT_VALUE_FORMAT as P } from "../DatePicker/DatePicker.constants.es.js";
import { DatePicker as V } from "../DatePicker/DatePicker.container.es.js";
const _ = ({ value: i, formikContext: o, name: r }) => {
  var l;
  return (l = o == null ? void 0 : o.values) != null && l[r] && (i = { date: m(o.values[r]) }), i;
}, X = ({
  endDate: i,
  endDateLabel: o,
  endDateName: r = "endDate",
  maxYear: l,
  minYear: I,
  onChange: d,
  startDate: D,
  startDateLabel: F,
  startDateName: u = "startDate",
  ...f
}) => {
  const a = O(L) ?? {}, [M, v] = n({}), [e, R] = n(
    _({ formikContext: a, name: u, value: D })
  ), [t, j] = n(
    _({ formikContext: a, name: r, value: i })
  ), y = w("RangeDatePicker", {}), A = S(
    (s) => {
      R(s), d == null || d({
        startDate: s.date,
        startDateIso: s.dateIso,
        endDate: t == null ? void 0 : t.date,
        endDateIso: t == null ? void 0 : t.dateIso
      });
    },
    [t, d, e]
  ), T = S(
    (s) => {
      j(s), s.date && (d == null || d({
        endDate: s.date,
        endDateIso: s.dateIso,
        startDate: e == null ? void 0 : e.date,
        startDateIso: e == null ? void 0 : e.dateIso
      }));
    },
    [e, d, t]
  ), U = E(() => {
    var c;
    let s = e == null ? void 0 : e.date;
    return (c = a == null ? void 0 : a.values) != null && c[u] && (s = m(a.values[u])), s ? { date: b(s, P) } : void 0;
  }, [e]), Y = E(() => {
    var c;
    let s = t == null ? void 0 : t.date;
    return (c = a == null ? void 0 : a.values) != null && c[r] && (s = m(a.values[r])), s ? { date: b(s, P) } : void 0;
  }, [e]);
  return q(() => {
    e != null && e.date && (t != null && t.date) && e.date > t.date ? v({ endDate: "Start date cannot be greater than end date" }) : v({});
  }, [e, t]), /* @__PURE__ */ g(z.div, { __css: y.root, children: [
    /* @__PURE__ */ p(
      V,
      {
        label: F,
        maxYears: l,
        minYears: I,
        mode: "single",
        name: u,
        onChange: A,
        value: U,
        ...f
      },
      "0"
    ),
    /* @__PURE__ */ p(
      V,
      {
        label: o,
        maxYears: l,
        min: e == null ? void 0 : e.date,
        minYears: I,
        mode: "single",
        name: r,
        onChange: T,
        value: Y,
        errors: {
          endDate: M.endDate
        },
        ...f
      },
      "1"
    )
  ] });
};
export {
  X as RangeDatePicker
};
//# sourceMappingURL=RangeDatePicker.es.js.map
